module.exports = __webpack_public_path__ + "img/shopifyplugin.93d70f10.png";